"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flattenDeep_1 = __importDefault(require("lodash/flattenDeep"));
var getStaticNodes = function (db, path) {
    if (db.dynamic.fns[path]) {
        var deps = db.dynamic.deps[path];
        return (0, flattenDeep_1.default)(deps.map(function (x) { return getStaticNodes(db, x); }));
    }
    else {
        return [path];
    }
};
exports.default = getStaticNodes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U3RhdGljTm9kZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vZ2V0U3RhdGljTm9kZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxtRUFBeUM7QUFFekMsSUFBTSxjQUFjLEdBQUcsVUFBQyxFQUFFLEVBQUUsSUFBSTtJQUM5QixJQUFJLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3hCLElBQUksSUFBSSxHQUFHLEVBQUUsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2pDLE9BQU8sSUFBQSxxQkFBTyxFQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxjQUFjLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxFQUFyQixDQUFxQixDQUFDLENBQUMsQ0FBQztLQUN4RDtTQUFNO1FBQ0wsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ2Y7QUFDSCxDQUFDLENBQUM7QUFFRixrQkFBZSxjQUFjLENBQUMifQ==